import { SubmissionState } from "@qw/graphql";
import { SUBMISSION_STATE_METADATA } from "@qw/ui";

const SUBMISSION_REPAIR_STATES: Partial<Record<SubmissionState, SubmissionState[]>> = {
  [SubmissionState.Declined]: [SubmissionState.ReadyToSubmit, SubmissionState.Submitted, SubmissionState.Referred],
  [SubmissionState.MarketBlocked]: [SubmissionState.Submitted, SubmissionState.Referred],
  [SubmissionState.RuledOut]: [
    SubmissionState.Pending,
    SubmissionState.ReadyToSubmit,
    SubmissionState.Submitted,
    SubmissionState.Referred,
  ],
};

// True only for the ~800 legacy submissions that have no transition logs: there is no
// previous state to revert to, so the broker has to pick the state to repair into.
export const canRepairSubmission = ({
  state,
  stateTransitions,
}: {
  state: SubmissionState;
  stateTransitions: readonly unknown[];
}) => stateTransitions.length === 0 && (SUBMISSION_REPAIR_STATES[state]?.length ?? 0) > 0;

export const getSubmissionRepairOptions = (state: SubmissionState) =>
  (SUBMISSION_REPAIR_STATES[state] ?? []).map((repairState) => ({
    label: SUBMISSION_STATE_METADATA[repairState].label,
    value: repairState,
  }));
